import {StyleSheet} from 'react-native';
import {COLORS, FONTS} from '../../../utils/Constants';

export default StyleSheet.create({
  container: (size, radius, bgColor) => ({
    height: size,
    width: size,
    borderRadius: radius,
    backgroundColor: bgColor,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  }),
  imageStyle: size => ({
    height: size,
    width: size,
  }),
  initialText: size => ({
    fontFamily: FONTS.regularFont,
    fontSize: size * 0.4,
    color: COLORS.white,
  }),
});
